export default `<script type='text/javascript'>
document.domain = 'qq.com';
console.log = function(...result) {
  window.parent.setIFrameResult('log', ...result);
};
window.Kconsole = {
    exec: function(code) {
        code = code || '';
        try {
            window.parent.setIFrameResult('result', window.eval(code));
        } catch (e) {
            window.parent.setIFrameResult('error', e);
        }
    }
}
</script>`;
